var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 0H2C1.46976 0.000617537 0.961408 0.211529 0.586469 0.586468C0.21153 0.961407 0.000617537 1.46976 0 2V28.6667C0.000617537 29.1969 0.21153 29.7053 0.586469 30.0802C0.961408 30.4551 1.46976 30.666 2 30.6667H38C38.5302 30.666 39.0386 30.4551 39.4135 30.0802C39.7885 29.7053 39.9994 29.1969 40 28.6667V2C39.9994 1.46976 39.7885 0.961407 39.4135 0.586468C39.0386 0.211529 38.5302 0.000617537 38 0ZM37.3333 2.66667V8H2.66667V2.66667H37.3333ZM2.66667 28V13.3333H37.3333V28H2.66667Z",
    fill: "#4E4B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H11.3333V22.6667H6V20ZM14 20H19.3333V22.6667H14V20Z",
    fill: "#4E4B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit_card_icon.aaac9d3a75d5e565686bad3791d11332.svg";
export { ForwardRef as ReactComponent };